import * as React from 'react';
import { trackSegmentWithAuth } from '@studio/helpers/trackSegmentWithAuth';
import { useSession } from '@studio/storeV2/authentication/session-store';
import type { Segment } from '@studio/types';

const useTrackSegment = () => {
  const { userName, customerName, customerId } = useSession();

  return React.useCallback(
    (payload: Segment.Derived.TrackSegmentPayload) => {
      trackSegmentWithAuth(payload, { userName, customerName, customerId });
    },
    [userName, customerName, customerId]
  );
};

export default useTrackSegment;
